module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_6.586f628b.jpg";